import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {CommonService} from "../../core/services/common.service";
import {HttpClientService} from "../../core/services/http-client.service";
import {ToastService} from "../../core/services/toast.service";
import {CartService} from "../../core/services/cart.service";
declare const window: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit{
  searchText: string = '';
  visible: boolean = false;
  pincode: string = this.common.getStorage(this.common.pincode) || '110001';
  stores: any[] = [];
  cart: any[] = [];
  showSearchBar: boolean = false;
  isLogin: boolean = false;
  url: any;
  activeIndex: any = 0;
  showSidebar: boolean = false
  isHomePage = true;
  nevMenu = [];
  selectedStoreCode: "dlsd135";

  constructor(private route: ActivatedRoute,private router: Router, private common: CommonService, private httpService: HttpClientService, private toast: ToastService, public cartService: CartService) {}

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isHomePage = this.router.url == '/';
      }
    });
    this.cartService.cart$.subscribe(cart => {
      this.cart = cart;
    });
    this.searchText = this.route.snapshot.queryParamMap.get('q');
    this.showSearchBar = !!this.searchText;
    this.getNavbar();
  }

  isHome(): boolean {
    return this.router.url === '/';
  }

  performSearch(): void {
    if (this.searchText.trim()) {
      this.router.navigate(['/search'], { queryParams: { q: this.searchText } });
    }
  }

  navigateToHome(): void {
    this.searchText = '';
    this.showSearchBar = false;
    this.router.navigate(['/']);
  }

  refresh() {
    window.location.reload();
  }

  toggleSearch() {
    this.showSearchBar = !this.showSearchBar;
  }

  querySearch() {
    this.common.obj.q = this.searchText;
    this.router.navigateByUrl(`/search?`+this.common.stringParams(this.common.obj))
  }

  makeActive(index) {
    this.activeIndex = index;
  }

  changePinCode() {
    let obj = {
      pinCode: this.pincode
    };

    this.httpService.get("postOffice", obj).subscribe(async (data:any) => {
        if (data.response.cities == "") {
          this.toast.warning("Invalid Pincode")
        } else {
          let objj = {
            pincode: this.pincode,
            fofoCode: this.common.getStorage(this.common.fofoCode)
          }
          this.common.pincodeChange.next({pinCode: this.pincode, url: '/'});
          this.common.setStorage(this.common.pincode, this.pincode);
          if (!objj.fofoCode) objj.fofoCode = "";

          const res = await this.httpService.get("store/addresses", objj).toPromise();

          if (res.response.length == 0) {
            this.stores=[];
            this.toast.info("No SmartDukaan Store NearBy");
            this.common.setStorage(this.common.storeCode, 'dlsd135');
            this.common.setStorage(this.common.pincode, this.pincode);
            if (!this.url) {
              this.common.pincodeChange.next({pinCode: this.pincode, url: '/'});
            }
            this.visible=false;
          } else if (res.response.length == 1) {
            let storecode = res.response[0].code.toLowerCase();
            if (this.common.getStorage(this.common.storeCode) != storecode) {
              this.visible = false;
              this.common.setStorage(this.common.storeCode, storecode);
              if (!this.url) {
                this.common.pincodeChange.next({pinCode: this.pincode, url: '/'});
              }
            }
          } else {
            this.common.setStorage(this.common.pincode, this.pincode);
            this.stores = [];
            for (let store of res.response) {
              this.stores.push(store)
            }
          }
        }
      },
      (error:any) => {
        if (error.statusCode == 400) {
          this.toast.error(error.response.message)
        } else {
          console.log("error", error)
        }
        this.visible=false;
      });
  }

  getStore(code: string) {
    const storeCode = code.toLowerCase();
    if (this.common.getStorage(this.common.storeCode) != storeCode) {
      this.common.setStorage(this.common.storeCode, storeCode);
      this.getToken(storeCode).subscribe(token => {
        if (token.statusCode == 200) {
          this.common.setStorage(this.common.newToken, token.response.token);
          this.common.setStorage(this.common.pincode, this.pincode);
          this.common.tokenStream.next('/');
          window.location.reload();
        }
      });
      if (this.url == null) {
        this.common.pincodeChange.next({pinCode: this.pincode, url: '/'});
      }
    }
    this.visible = false;
  }

  public getToken(storeCode: string) {
    return this.httpService.get(`store/token/${storeCode}`);
  }

  public getStoreAddress(pinCode = '') {
    return this.httpService.get(`store/address/${pinCode}`);
  }

  logOut(){
    this.common.removeStorage('customer');
    this.common.setLoggedIn(false);
    this.router.navigate(['/']);
  }
  goBack() {
    window.history.back();
  }
  isLoggedIn() {
    return this.common.isLoggedIn();
  }

  getNavbar(){
    this.httpService.get('store/navbar').subscribe((data:any)=>{
      if (data.responseStatus.toLowerCase() == 'success') this.nevMenu = data.response;
    })
  }

  async openUrl(url: string){
    await this.common.openInBrowser(url);
  }

}
